import type { IStoredToken } from "web/types/Token";

let storedToken: IStoredToken | null = null;

export const getStoredToken = (): IStoredToken | null => storedToken;

export const setStoredToken = (token: IStoredToken | null): void => {
  storedToken = token;
};

/** Clears in-memory cached token. Call on logout to prevent stale state. */
export const invalidateStoredToken = (): void => {
  storedToken = null;
};
